import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation';
import zhTranslation from './locales/zh/translation';

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    debug: false,
    lng: 'zh', // Set default language to Chinese
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    resources: {
      en: {
        translation: enTranslation
      },
      zh: {
        translation: zhTranslation
      }
    },
    detection: {
      order: ['cookie', 'navigator', 'htmlTag', 'path'],
      lookupFromPathIndex: 0,
      caches: ['cookie']
    }
  });

export default i18n; 